var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9783 4.97665L9.88739 0.885742H3.0692C2.31648 0.885742 1.70557 1.49665 1.70557 2.24938V14.5221C1.70557 15.2748 2.31648 15.8857 3.0692 15.8857H12.6147C13.3674 15.8857 13.9783 15.2748 13.9783 14.5221V4.97665Z",
    stroke: "#00A3FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88721 0.885742V4.97665H13.9781",
    stroke: "#00A3FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.b51c2a87cdb3f02c460f1d32fa63bf3a.svg";
export { ForwardRef as ReactComponent };